import React, { useEffect } from "react";
import { MountainSnow, Home, Sunrise, Route, UtensilsCrossed } from "lucide-react";

const AREA_QA = [
  {
    icon: MountainSnow,
    q: "Where can I stay in Munnar with scenic mountain views close to Sengulam Dam?",
    a: "Auracrest Haven is a luxury homestay near Sengulam Dam in Anachal, Muthuvankudy — set amid cardamom and nutmeg plantations with sweeping Western Ghats mountain views. You wake up to misty hills and forest, yet stay just 18–20 km from Munnar town and minutes from the tranquil Sengulam Dam reservoir.",
  },
  {
    icon: Home,
    q: "Do you have A-frame cottages in Anachal, Munnar?",
    a: "Yes. Auracrest Haven offers striking A-frame cottages in Anachal, Munnar that comfortably sleep 3 to 5 guests, alongside deluxe rooms for 2 to 3 guests. Every unit is finished with modern interiors, 24-hour hot water and power, and most open onto a view of the plantations and hills.",
  },
  {
    icon: Sunrise,
    q: "Is there a private cottage stay with a balcony view in Munnar?",
    a: "Absolutely. Our private cottage stay in Munnar comes with balconies that look straight out over the forest canopy and distant peaks — perfect for morning coffee, birdwatching or a quiet honeymoon retreat. It is one of the most peaceful balcony-view stays near Anachal and Sengulam Dam.",
  },
  {
    icon: Route,
    q: "How far is Auracrest Haven from Munnar town and Kochi airport?",
    a: "We are about 18–20 km (a 35–40 minute scenic drive) from Munnar town centre, and roughly 110 km / 3.5–4 hours from Cochin International Airport (COK), the nearest airport. We can arrange a cab pickup from Kochi airport or Munnar town on request.",
  },
  {
    icon: UtensilsCrossed,
    q: "Is there a homestay near Sengulam Dam with home-cooked food and fine dining?",
    a: "Yes — Auracrest Haven is a family-run homestay near Sengulam Dam serving authentic home-cooked Kerala meals, and our on-site SpyzzZ Restaurant offers scenic fine dining with forest views. Free 24-hour tea and coffee, filtered spring water and complimentary parking are included with every stay.",
  },
];

const AboutArea = () => {
  useEffect(() => {
    const data = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: AREA_QA.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    let s = document.getElementById("area-jsonld");
    if (!s) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "area-jsonld";
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(data);
    return () => {
      const el = document.getElementById("area-jsonld");
      if (el) el.remove();
    };
  }, []);

  return (
    <section id="area" className="py-20 md:py-28 bg-neutral-50" data-testid="about-area">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <div className="text-center mb-14">
          <p className="text-xs font-semibold tracking-[0.25em] uppercase text-[#17a89b] mb-4">
            About the Area
          </p>
          <h2 className="text-3xl md:text-5xl font-extrabold text-neutral-900 mb-4 leading-tight">
            A-Frame Cottages &amp; Luxury Homestay near Sengulam Dam, Anachal
          </h2>
          <p className="text-neutral-600 max-w-3xl mx-auto leading-8">
            Planning a trip to Munnar? Here are honest answers to the questions travellers ask us most
            about staying near Anachal and Sengulam Dam.
          </p>
        </div>

        <div className="space-y-5">
          {AREA_QA.map((item, i) => (
            <div
              key={i}
              data-testid={`area-qa-${i}`}
              className="bg-white rounded-2xl p-6 md:p-8 shadow-sm flex flex-col md:flex-row gap-5 md:gap-7"
            >
              <div className="w-12 h-12 shrink-0 rounded-xl bg-[#e3faf7] flex items-center justify-center">
                <item.icon className="w-6 h-6 text-[#17a89b]" />
              </div>
              <div>
                <h3 className="text-lg font-bold text-neutral-900 mb-2 leading-snug">{item.q}</h3>
                <p className="text-neutral-600 leading-8">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutArea;
